import React, { CSSProperties, FC } from "react";
import styled from "styled-components";
import { CircularProgress } from "@evergis/ui";

const LoaderContainer = styled.div<{ fixed?: boolean }>`
  position: ${({ fixed }) => (fixed ? "fixed" : "absolute")};
  bottom: 0;
  left: 0;
  z-index: 5;
  width: 100%;
  height: calc(100% - 8rem);
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.46);
`;

interface LoaderProps {
  fixed?: boolean;
  style?: CSSProperties;
}

export const Loader: FC<LoaderProps> = ({ fixed, style }) => (
  <LoaderContainer fixed={fixed} style={style}>
    <CircularProgress diameter={6} />
  </LoaderContainer>
);
